import styled from "styled-components";
import Select from "react-select";

export const InputWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const InputReactSelect = styled(Select)`
  box-sizing: border-box;

  font-size: ${(props) => (props.fontSize ? `${props.fontSize}` : "14px")};
  width: 100%;
  width: ${(props) => (props.width ? `${props.width}` : "auto")};
  height: ${(props) => (props.height ? `${props.height}` : "40px")};
  border: 1px solid ${(props) => props.theme.colors.gray100};
  border-radius: ${(props) => props.theme.radii.xs};
`;
